import { DeviceHealth } from 'types';

export const deviceHealthSorter = (v: DeviceHealth, v2: DeviceHealth) =>
    v.icon === 'Laptop' && v2.icon === 'Laptop'
        ? 0
        : v.icon === 'Laptop' && v2.icon !== 'Laptop'
        ? 1
        : -1;
